<div [ngClass]="isFavoritesCollapsed ? 'collapsed' : 'expanded'" class="sidebar-item">
  <div (click)="toggleFavorites(favoritesCollapse)" class="sidebar-item-head">
    <h3 class="h6 mb-0 text-white">
      <i class="fa-solid fa-star mr-2"></i>
      {{'Favorites' | translate}}
      @if (displayFavoritesItems) {
        <span class="badge badge-pill badge-primary ml-1" [innerText]="numberOfFavoritesItems"></span>
      }
    </h3>
  </div>
  <div #favoritesCollapse="ngbCollapse" [(ngbCollapse)]="isFavoritesCollapsed" [animation]="false" class="sidebar-item-content">
    <div class="menu menu-favorites">
      <!-- Favorites -->
      <div class="menu-content">

        <!-- Fallback when no favorites are set -->
        @if (!displayFavoritesItems) {
          <div class="alert alert-light text-center mb-0">
            <span class="fa-solid fa-star h3 text-light"></span>
            <p class="mb-0" translate>First add menu favorites below.</p>
          </div>
        }

        @if (displayFavoritesItems) {
          <div>
            @for (favoriteMenuItem of menuFavoriteItems; track favoriteMenuItem) {
              <scitis-favorite-item (menuItemSelected)="onMenuItemSelected($event)"
                [menuFavoriteItem]="favoriteMenuItem" [ngClass]="getClass(favoriteMenuItem)">
              </scitis-favorite-item>
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>